import React from "react";

function Footer() {

    return (<section className="footer-section">

    </section>);
}

export default Footer;